import columns from '../../../../../react-table/helpers/columns';
import { sumTotal } from '../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Report', 'reportName').withTotalHeader('Total').withWidth(300),
        new NonZeroNumberColumn('Queries', 'queries').withTotalHeader(sumTotal).withWidth(80),
      ],
    },
  ];
};
